// extracted by mini-css-extract-plugin
module.exports = {"root":"Toolbar_root__1QCDD","lightBg":"Toolbar_lightBg__2xqpa","darkBg":"Toolbar_darkBg__1SRmY"};